import * as React from 'react'
import {Text} from 'wix-ui-tpa/Text'
import classNames from 'classnames'
import s from './label-with-value.scss'
import {LabelWithValueProps} from '.'

export const LabelWithValue = ({label, labelClassName, value}: LabelWithValueProps) =>
  value ? (
    <div className={s.labelWithValue}>
      <Text className={classNames(s.smallText, labelClassName ?? s.smallTextColor)}>{label}</Text>
      <Text className={s.value}>{value}</Text>
    </div>
  ) : null
